import React, {useState} from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled'
import { Accordion, IItem as IIccordionItem } from '~common/accordion'
import { useIsMobile } from "~helpers/hooks/useIsMobile";
import { AmplitudeCounter } from "~/amplitude-counter";

const RoutineTasksScreen = () => {
  const isMobile = useIsMobile();
  const [activeItemIndex, setActiveItemIndex] = useState(0)
  const questions: IIccordionItem[] = [
    {
      title: 'Устали вести клиентов в Excel?',
      text: <span>Мы сделали интеграцию с 30+ CRM-системами, включая amoCRM, Bitrix24, Yclients, GetCourse, Roistat, UseDesk и многие другие.<br /><br /><a
        href="https://onlinepbx.evateam.ru/docs/docs/DOC-000124#sravnitelnaya-tablicza-integraczij" target='_blank'>Смотреть полный список</a></span>
    },
    {
      title: 'Слишком много систем для работы?',
      text: 'Виджет amoCRM позволяет звонить и принимать звонки внутри CRM-системы. В карточку клиента автоматически подтягивается запись разговора и оценка качества. Ваши сотрудники работают в режиме “одного окна”.'
    },
    {
      title: 'Менеджеры тратят время на рутинные задачи?',
      text: 'Подключите автоинформатор от onlinepbx. Система сама обзвонит клиентов по сформированному вами списку и воспроизведет аудиосообщение. Идеально для однотипных сообщений.'
    }
  ]

  const iconsDictionary = [
    [
      <img key='icon_1' width='382px' src={process.env.PUBLIC_DIR + '/images/index_page/routine_tasks/icon_1.svg'}  alt='Устали вести клиентов в Excel?' />,
      <img key='mobile_icon_1' src={process.env.PUBLIC_DIR + '/images/index_page/routine_tasks/mobile_icon_1.png'}  alt='Устали вести клиентов в Excel?' />
    ],
    [
      <img key='icon_2' width='382px' src={process.env.PUBLIC_DIR + '/images/index_page/routine_tasks/icon_2.svg'}  alt='Слишком много систем для работы?' />,
      <img key='mobile_icon_2' src={process.env.PUBLIC_DIR + '/images/index_page/routine_tasks/mobile_icon_2.png'}  alt='Слишком много систем для работы?' />
    ],
    [
      <img key='icon_3' src={process.env.PUBLIC_DIR + '/images/index_page/routine_tasks/icon_3.png'}  alt='Менеджеры тратят время на рутинные задачи?' />,
      <img key='mobile_icon_3' src={process.env.PUBLIC_DIR + '/images/index_page/routine_tasks/mobile_icon_3.png'}  alt='Менеджеры тратят время на рутинные задачи?' />
    ],
  ]

  return (
    <Screen
      id='automate_routines'
      title={!isMobile && <span><StyledScreen.GreenText>Автоматизируйте</StyledScreen.GreenText> рутинные задачи</span> || null}
    >
      <Styled.Container>
        <Styled.Left>
          {
            iconsDictionary.map((icon: any, index: number) => (
              <Styled.IconWrapp isShowed={index === activeItemIndex}>
                {
                  isMobile && icon[1] || icon[0]
                }
              </Styled.IconWrapp>
            ))
          }
        </Styled.Left>
        <Styled.Right>
          <Accordion
            data={questions}
            initialElemIndex={0}
            onChange={(index: number, item: IIccordionItem) => {
              setActiveItemIndex(index)
              AmplitudeCounter('click_open_question', { question: item.title })
            }}
          />
        </Styled.Right>
      </Styled.Container>
    </Screen>
  )
}

export { RoutineTasksScreen }
